let EmailRecipients = {
  mounted() {
    this.el.addEventListener("click", (event) => {
      // Clicking somewhere in the "To"/"CC"/"BCC" container should focus
      // on the editable email address.
      if ("focusOnEditable" in event.target.dataset) {
        event.target.querySelector('input[type="text"]').focus()
      }
    })
  },
}

export { EmailRecipients }
